import { render } from "./Garage.vue?vue&type=template&id=74ffa22a"
import script from "./Garage.vue?vue&type=script&lang=js"
export * from "./Garage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__